import { useParams } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import InstallFlow from "./InstallFlow";

export default function InstallFlowPage() {
  const { claim } = useParams();
  if (!claim) {
    return (
      <MDBox p={3}>
        <MDTypography>Missing claim code.</MDTypography>
      </MDBox>
    );
  }
  return <InstallFlow claimCode={claim} />;
}
